
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93slgVK3wF7HrQT7zBsGWZ_vpVTmtlT7ptZlRoq0UmhAcMeta } from "/app/pages/dashboard/services/packages/edit/[id].vue?macro=true";
import { default as purchasestcUTbqmTqwdlVg9UjvbMZU2I0lhL2YS5T0cYEAR_EsgMeta } from "/app/pages/dashboard/services/packages/purchases.vue?macro=true";
import { default as _91id_93qHY6US4fX_zr9WLPSBdhqSmD_L_A_Jt8WyWK9B_1ayEMeta } from "/app/pages/dashboard/booking/virtual-visits/[id].vue?macro=true";
import { default as _91id_93MX_Envs8EI0i8qSy0EFnTCDGL6ojW1brN_syHpjJ6OEMeta } from "/app/pages/dashboard/health/entries/[id].vue?macro=true";
import { default as _91id_93qjPXePcbsKKW__LidX3OE4ca8jlh94gQQCgX3YDvylkMeta } from "/app/pages/dashboard/health/forms/[id].vue?macro=true";
import { default as _91id_935UzfVipLJion6SNYHCcS9Y6dD20Tl55WS1Z5Gvb_0VgMeta } from "/app/pages/dashboard/health/print/[id].vue?macro=true";
import { default as analyticsPCARd7pZyFTOIaIBaC3Y4BFn43iel2PdDOvEyLorcw8Meta } from "/app/pages/admin/error-logs/analytics.vue?macro=true";
import { default as categoriesAx16RZ9zO1Ssgc_HLKO6bIl4Knlx6gwl6qpi_B5AElUMeta } from "/app/pages/dashboard/blog/categories.vue?macro=true";
import { default as commentsv_CjCzJbk6r_RAKqMcFONWU9_rUCHus6eONI__jl_VsMeta } from "/app/pages/dashboard/blog/comments.vue?macro=true";
import { default as newDdpAg4CTg5HosXoz_gMmBDl6HbFM7qmZ3tBm57RkaYMMeta } from "/app/pages/dashboard/blog/new.vue?macro=true";
import { default as settingsuWVZju_4ozEjgnJu0atbzXJdPd7SadanEot5bJhN0qEMeta } from "/app/pages/dashboard/blog/settings.vue?macro=true";
import { default as cancellationsWDEys8sP_ybFdk5EupUkqRowZL7Y2s21qBuSaj69stIMeta } from "/app/pages/dashboard/booking/cancellations.vue?macro=true";
import { default as doctorsMT8opMp7ZcGNmujmOzlK4_mwbLZOHoMOKhffygrR07kMeta } from "/app/pages/dashboard/booking/doctors.vue?macro=true";
import { default as scheduleEKkBlK5H_Ttc3gVVLAniWKWmg80kv7jmnFfE_Z_5dG8Meta } from "/app/pages/dashboard/booking/schedule.vue?macro=true";
import { default as services62BBMFhay4odRzoGvrDw4yLxB0_r34Cms8IbHpg5Sx0Meta } from "/app/pages/dashboard/booking/services.vue?macro=true";
import { default as settings4K6q_KRrrdACjCnymaQP39xpzwsDCeAjbl5HyQk5_2UMeta } from "/app/pages/dashboard/booking/settings.vue?macro=true";
import { default as indexi1Jqjj0UECiRS2XmIACA5gqRCKzxFx23GVDmxYg8IhAMeta } from "/app/pages/dashboard/booking/virtual-visits/index.vue?macro=true";
import { default as analyticsMkZST0wEjbmz3EG1yrNslOBr5BpBfUfKCiZxGCLqysoMeta } from "/app/pages/dashboard/campaign/analytics.vue?macro=true";
import { default as couponsFfunlu7zDjvlSa9gINZDzxqCgnX1fL_hZlDfeIPCHz8Meta } from "/app/pages/dashboard/campaign/coupons.vue?macro=true";
import { default as flash_45salesb20Fm3uIX7yfqUD_3GTmh9gyidRuEcJ56tL9PPiHzQUMeta } from "/app/pages/dashboard/campaign/flash-sales.vue?macro=true";
import { default as gift_45cards66_EX0whyXcEiMf_wtsh5CmsLcUwhnqfnfAGbF9kSvEMeta } from "/app/pages/dashboard/campaign/gift-cards.vue?macro=true";
import { default as landings5v_aRbiDU3RlCR_fiBDYpu8_YBouCvMfY7D4RgyiLt0Meta } from "/app/pages/dashboard/campaign/landings.vue?macro=true";
import { default as occasionsedm2MlfizbDDNqhbgyfHN_LvPoPlX_Aj6Gw3BSyf01QMeta } from "/app/pages/dashboard/campaign/occasions.vue?macro=true";
import { default as settingskvRjyED3krdXw8QNbj5EMsFAg_WDVZ1epXMc1NMAFSMMeta } from "/app/pages/dashboard/campaign/settings.vue?macro=true";
import { default as smsyhEdlb88Fj_BTBmadrqJegEIgKg2cv4FiLJK1YS_su0Meta } from "/app/pages/dashboard/campaign/sms.vue?macro=true";
import { default as spinby4C0D_05CD8YJarpfQgIBWW7K3iAUEfTujKGWloHlgMeta } from "/app/pages/dashboard/campaign/spin.vue?macro=true";
import { default as subscribers0NcXb2lNzOuy1KNvv3wevjuwfIEt8RbHwJwIK1orPq0Meta } from "/app/pages/dashboard/campaign/subscribers.vue?macro=true";
import { default as index1s3p8HVImFYqzFG9AFPj0LasCP3yyd__3j6mp9otjZEMeta } from "/app/pages/dashboard/health/forms/index.vue?macro=true";
import { default as ambassadors0CGS0qk4x7Lf5PJcxrnsiiqU0jcQ_S7mkNXn6ANFHUIMeta } from "/app/pages/dashboard/leads/ambassadors.vue?macro=true";
import { default as analyticsAqWK4TDj0e2gmb81SDaKynK_qKWtSFGb3Mh0K_IuQVIMeta } from "/app/pages/dashboard/leads/analytics.vue?macro=true";
import { default as calculatorsf0bUEL8sRGl_LXXvr6CMQazj1_uQ1_fT3oH121__Ta8Meta } from "/app/pages/dashboard/leads/calculators.vue?macro=true";
import { default as chat6ukVGNsejCC2aZjaxXLQE9hzeZpGodgCIKT8tycsLzAMeta } from "/app/pages/dashboard/leads/chat.vue?macro=true";
import { default as guidesNgf_KMh3bJ82LqjotY6BIwZBlo0Ga5MZbzMrIWz12_cMeta } from "/app/pages/dashboard/leads/guides.vue?macro=true";
import { default as inbox2cuKDCMcvvAetdykHF9lseVvqX34MI36LK30c06jyD8Meta } from "/app/pages/dashboard/leads/inbox.vue?macro=true";
import { default as magnetss9XkDeqD959WyasGtDMcGv3RSwKphmEfEX_xPOza10MMeta } from "/app/pages/dashboard/leads/magnets.vue?macro=true";
import { default as quiz_45resultsjnGwQxcGapggRRNffom649Q8NBdowzBp0T2BqqpZxi4Meta } from "/app/pages/dashboard/leads/quiz-results.vue?macro=true";
import { default as quizzesCQSPN_t3H2wzieRam5saPpm8D1BPtQC71bPl32O0HUIMeta } from "/app/pages/dashboard/leads/quizzes.vue?macro=true";
import { default as settingsrTLDofWafWEK_NhWy_2Zo3aQ0ti7BRucNifH2CmcvpEMeta } from "/app/pages/dashboard/leads/settings.vue?macro=true";
import { default as surveysnnJHJXXk_1yvQXuBffTFXHj0o3O3Vhj4SBzL4_bxgcoMeta } from "/app/pages/dashboard/leads/surveys.vue?macro=true";
import { default as waitliststw95IcMEUEJ8CaPhMEotLHyUMR9X0QkQGxXfX8bovnAMeta } from "/app/pages/dashboard/leads/waitlists.vue?macro=true";
import { default as webinarsE_lt8VfaQczOJ_6bfSTC8nNtJVz40Hsb1Vbn1_DoS4kMeta } from "/app/pages/dashboard/leads/webinars.vue?macro=true";
import { default as index9kwLWivOlITQdwC3SwZicgbDOn8fHgUmaSTigG_6_mQMeta } from "/app/pages/dashboard/services/packages/index.vue?macro=true";
import { default as analyticsTZ4l_MAXG4FugC7wdGWiFbr_ELf8fH6tfb4rvG7pQP4Meta } from "/app/pages/support/error-logs/analytics.vue?macro=true";
import { default as _91id_93z9r2rj5amWv3guicXHVmPNjkOPQ9V85Xp35i1uzEEDsMeta } from "/app/pages/admin/error-logs/[id].vue?macro=true";
import { default as _91id_93x6H7zA8mo0IB39UX_Vsp_eljH6aZSNi1_xbht_tvut0Meta } from "/app/pages/admin/sites/[id].vue?macro=true";
import { default as _91id_93A4mg1wwSwmMq5jvrpzB0krtBf97kmL3y7cKJxODAmYIMeta } from "/app/pages/admin/tickets/[id].vue?macro=true";
import { default as _91slug_93_O_aKhw5Dme3hJQEXkujs_ucVTbqukF3Am1DybvDPXUMeta } from "/app/pages/blog/category/[slug].vue?macro=true";
import { default as _91id_93eLhgBAnCzhMgTMk__fycxzBBh8vM6nagQFVeLiSgxGMMeta } from "/app/pages/dashboard/blog/[id].vue?macro=true";
import { default as _91id_93be_MSmtxf2i_Fc_wAhYg02GgqmdGcjHYASJVpLAPUnUMeta } from "/app/pages/dashboard/health/[id].vue?macro=true";
import { default as _91id_93KtHqEO_VGQ0VgGcogH9NBmj22uxLkfpSV5pjYBH1xS4Meta } from "/app/pages/dashboard/reception/[id].vue?macro=true";
import { default as _91id_93sX2_MPmwUnA3btdJdzb1kdeLntudEygNfJdLfMedTLYMeta } from "/app/pages/dashboard/service-pages/[id].vue?macro=true";
import { default as _91id_93HM2ZohmRcOeNtaHHBj_ZoubXD2_EilfUck0CZldfFn0Meta } from "/app/pages/dashboard/tickets/[id].vue?macro=true";
import { default as _91id_938ezCN529qgm_Lo5HwMP8TjAur5tY_DotyR1sNyyQro8Meta } from "/app/pages/patient/forms/[id].vue?macro=true";
import { default as _91id_93o_JxfsbSIvaSzcqDI7J6e_Q92bolqlOuGdKKFMGou2gMeta } from "/app/pages/patient/visits/[id].vue?macro=true";
import { default as _91id_93EV0_jzqzlQeDtByJcUzdemquKqbDBbUrcihKSLj_3xIMeta } from "/app/pages/support/customers/[id].vue?macro=true";
import { default as _91id_93cxzTePpwwRUKzEX0Feb5idKwSgBFvx_QNufRli_XEvcMeta } from "/app/pages/support/error-logs/[id].vue?macro=true";
import { default as _91id_93vdNECoYPA77tmmqmeYOlXb6hNI5F7a0d8x_AuEAdSGkMeta } from "/app/pages/support/tickets/[id].vue?macro=true";
import { default as adminsWfgSiwLQYfvQx7Xi9OKeSg2LGrvBrUqeB6dLRGIJ_LIMeta } from "/app/pages/admin/admins.vue?macro=true";
import { default as domain_45requests_gqI_bZVglBZ3V3ZESQuJ5xKfvGiV8eW__ABz5eZH7YMeta } from "/app/pages/admin/domain-requests.vue?macro=true";
import { default as indexoiazOuBt7eVIrvw7grQ9oIDn7Uio9ZUFUzQjS0I6as0Meta } from "/app/pages/admin/error-logs/index.vue?macro=true";
import { default as modules4OO_5zVxEo3uyTz7yV2jvqmdzVcMrUoZwqQ0IgzeCEEMeta } from "/app/pages/admin/modules.vue?macro=true";
import { default as otpbWoaE7spMJ2pPFmBwwV8II0YQkQpjbCxn8Dm9dgbO00Meta } from "/app/pages/admin/otp.vue?macro=true";
import { default as payment_45gateways4Rr_zGJhf_7fTD3wHb1F6egaxKHfhhkenANWDciXXEgMeta } from "/app/pages/admin/payment-gateways.vue?macro=true";
import { default as paymentsDTc0YZeXYu6Cf6_beJ0BxGHbRp8hOu0wiiCt4WRp_lEMeta } from "/app/pages/admin/payments.vue?macro=true";
import { default as plansf_rNqftrad6C_t8OOFQWSmzO1xUexRaeZikCautzx50Meta } from "/app/pages/admin/plans.vue?macro=true";
import { default as settingsjpINHYWlqSsBB0Ri3ol_ZETwEd_od9UBgDjfk0FEzswMeta } from "/app/pages/admin/settings.vue?macro=true";
import { default as indexlR41HLCXvLKGrOFGoCkkgI0liI_BUsVCU2d8ebKpxMkMeta } from "/app/pages/admin/sites/index.vue?macro=true";
import { default as smsFRTR9kJSvuP_b2fmFqWgSlL7NwQgdVCVkewvfVUydl4Meta } from "/app/pages/admin/sms.vue?macro=true";
import { default as subscriptionsAS0WW2vkVJeFG6ogK8uSyrnmSsY6dW0mDIARAWkPFwQMeta } from "/app/pages/admin/subscriptions.vue?macro=true";
import { default as indexYk_vvFG2F2lBBb9vaEQRBB6X_ih2XGs3esDOPOj1DO8Meta } from "/app/pages/admin/tickets/index.vue?macro=true";
import { default as users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta } from "/app/pages/admin/users.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as profile5k5vtiSyQyYiZEu4MaSnWXv0WRuRTfTShdWLs8DEpZAMeta } from "/app/pages/auth/profile.vue?macro=true";
import { default as signupsTWjhAgrrNIHjZDxwXTWWZ6X6mjwk7GNfKEQ1VBvxXYMeta } from "/app/pages/auth/signup.vue?macro=true";
import { default as verifyq0rdI8J2xjZY_VQRxtPkTGXIw3ug8qIWqnlYpxXAgqMMeta } from "/app/pages/auth/verify.vue?macro=true";
import { default as indexcH6_GAvMqYT_Jag2xcNuwrIkdyB62MHk5Qn0f6S5R6cMeta } from "/app/pages/dashboard/blog/index.vue?macro=true";
import { default as indexZ5zvTBQoLm80WXhZfzoHrKBo_ml0fy71AVORbVLHNlEMeta } from "/app/pages/dashboard/booking/index.vue?macro=true";
import { default as indexApuwjk9rdw7RBYQbLWBb__Aauc4dpIDJh5Yh7e8hbxMMeta } from "/app/pages/dashboard/campaign/index.vue?macro=true";
import { default as domaineC_FOWF2al6Z6mQrB0hGMNGjQE7b_sAW7Ss2ZPECEiMMeta } from "/app/pages/dashboard/domain.vue?macro=true";
import { default as indexgx1slA3NqKPuZXXXxLXyQziH6L0ds25uEtZNhKf1KrwMeta } from "/app/pages/dashboard/health/index.vue?macro=true";
import { default as indexrNaORmWKZ038roLYh_a7Mplrn0ANq22e4Qk6a66XnXUMeta } from "/app/pages/dashboard/leads/index.vue?macro=true";
import { default as payment_45gateways39xPdd8d1BEY0OjLHB0j4sibz6KdhGlBbZeuDnBLWYYMeta } from "/app/pages/dashboard/payment-gateways.vue?macro=true";
import { default as practice0frb2IeIVUIyPft_3PSUYquqfnsuGazJZ2eOs17S2vgMeta } from "/app/pages/dashboard/practice.vue?macro=true";
import { default as indexnU1yot9T0uB8jQv8YYMmdGdde9hpxiJpseiP5KTnW4oMeta } from "/app/pages/dashboard/reception/index.vue?macro=true";
import { default as indexecw_uaHHaOAOVco5Cd9U5OkTx281lQ69WkN7ivn_AsUMeta } from "/app/pages/dashboard/service-pages/index.vue?macro=true";
import { default as index_krImHr_ip9C52U3ZcSQDrauWI0_ZyXKqSf5ywV_xocMeta } from "/app/pages/dashboard/services/index.vue?macro=true";
import { default as settingsdbGcSVbrN6nxlDN_PE7jX29jsE03Vh_dTSCKrsal9FwMeta } from "/app/pages/dashboard/settings.vue?macro=true";
import { default as subscriptionoGNuuzwwRnGCxxxZT4ksH4_tPYRSkAZiZXpe3pFtU38Meta } from "/app/pages/dashboard/subscription.vue?macro=true";
import { default as indexO3Bf0r2Qui8dNv6GnAVugiJLqcCLrBSvLniOtEZzh4MMeta } from "/app/pages/dashboard/tickets/index.vue?macro=true";
import { default as unavailableA2Q2UbuApuspdc1MQ7gPZ3bwajTsiIKKYddIP6IP0S8Meta } from "/app/pages/dashboard/unavailable.vue?macro=true";
import { default as appointmentszUYu4Pg3Ptmv4voA6a1eroYVDbz6W2RNhAs36PfIz4UMeta } from "/app/pages/patient/appointments.vue?macro=true";
import { default as chatrL4C0__kOZnnZlejhFJwoVhrv6xIX9nXXCr8ITk8lY0Meta } from "/app/pages/patient/chat.vue?macro=true";
import { default as indexxk_VHooWcjQG1OiSFHmPe6hCvTwRvFXiFvGjaJBtUpMMeta } from "/app/pages/patient/forms/index.vue?macro=true";
import { default as giftsNcBNGOFchJV2t_Om_IR73tLNaOxxI3rrjpUrmUOXC4AMeta } from "/app/pages/patient/gifts.vue?macro=true";
import { default as indexk2xlK1MET4J_V8MgfZT8dt713uznQfBAODlw6lfmOvcMeta } from "/app/pages/patient/health/index.vue?macro=true";
import { default as loginpGLL451mWZpF3Flf_71h2MuAT_MglreN3xW5EPbTdTkMeta } from "/app/pages/patient/login.vue?macro=true";
import { default as packagespV9asTy2TQhPdpN1PVpeSbSW__HXX7mwzemMDHmWeHEMeta } from "/app/pages/patient/packages.vue?macro=true";
import { default as pointsOsg5C23cRhQMKO46rapl5EjYwnPCy7JoPVYOztu_L08Meta } from "/app/pages/patient/points.vue?macro=true";
import { default as profileHzp28yqy6ykRMuWyKDbzC5ND84H3FiD9GdvJgnopIfcMeta } from "/app/pages/patient/profile.vue?macro=true";
import { default as record4B5zGKYXVgBcz9DIdORvnliit3MABT0HiFgakBmctzAMeta } from "/app/pages/patient/record.vue?macro=true";
import { default as referralDgaWcqUoalF_UJDdndlddHxi_pv04kKxMs5D3Vs8av0Meta } from "/app/pages/patient/referral.vue?macro=true";
import { default as indexTIm_BN3UF2jp5qCFUZSYwe4oKeoQ_ofmAjXZnBU4NO0Meta } from "/app/pages/patient/visits/index.vue?macro=true";
import { default as indexoDuHZjeAvW_ExMRCvtpghE65BL8wZPOGym3T4KAdztoMeta } from "/app/pages/support/customers/index.vue?macro=true";
import { default as index2Uh9UP7nHPDogjcaZmJ8O95THqLfFJUqAlIcYbLvkVoMeta } from "/app/pages/support/error-logs/index.vue?macro=true";
import { default as settingsKa_mj2fZrNKcJcWCj40THWWArojBGMOiOmySucJq8rYMeta } from "/app/pages/support/settings.vue?macro=true";
import { default as indexKI0bnCP6LbOBPECT_S8OTc9nUxH_lM0xEsj9ZN8yz4gMeta } from "/app/pages/support/tickets/index.vue?macro=true";
import { default as guestkOCPpnzrf8_fWXI29oDyF78jSwx1n36a_KNnC2O4A_0Meta } from "/app/pages/virtual-visit/guest.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93lHFnCfzBCX6toHx_NkfR_QiDMqLnm3c3erUiwxvXhbMMeta } from "/app/pages/c/[slug].vue?macro=true";
import { default as step_45_91n_93VLUY6hBVoDcZHYwMyWaP5O06gxC36hFpumCgRCrEkIAMeta } from "/app/pages/onboarding/step-[n].vue?macro=true";
import { default as _91id_93VXOhvzN8Z8rEzyt3SexOaM0PYmYCgU8VBGDjzwqaV70Meta } from "/app/pages/packages/[id].vue?macro=true";
import { default as _91serviceRef_938QGGNxMRAbh4imySvGxmx1GEsszyKVTBz_d7YdbsuLIMeta } from "/app/pages/services/[serviceRef].vue?macro=true";
import { default as about3BeDYJHafdz3_0F8I84XDeTlPVmsANEPp0qlI_udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as appointmentnSC6UR4mgVct6MO3R14q3IWIw7dvmm_rDfYUhPqMObQMeta } from "/app/pages/appointment.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as booking33tFJxD50XdhLz_nPee8UtbBXk6Y5rw__W3w4wkpB10Meta } from "/app/pages/booking.vue?macro=true";
import { default as builderK7krtFYjP4WCC9BkWFXj2293muDlEtS8rmD7JZOEdL8Meta } from "/app/pages/builder.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as index_F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta } from "/app/pages/onboarding/index.vue?macro=true";
import { default as indexJShk27dRSWfsze5T07DMDSKRnqsALdb8h6oYoL56uS0Meta } from "/app/pages/patient/index.vue?macro=true";
import { default as pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta } from "/app/pages/pricing.vue?macro=true";
import { default as sOTPUa0_KsI6Xik_AY2rqzE3mT8ZwkSO0SQnjJfkW2mIMeta } from "/app/pages/s.vue?macro=true";
import { default as indexjRtHzhS_dpsR_NlfsCCACFtIpspax8jcPZapdKX7vF0Meta } from "/app/pages/services/index.vue?macro=true";
import { default as shop1_Y_ssmWg_o_nR3Bp60pPblf_qjzasBy_DGRDWYMOL4Meta } from "/app/pages/shop.vue?macro=true";
import { default as startuRzeDbyJkSLhdTfbRgMw5v72qjn8J_EMjWHBkmTaqloMeta } from "/app/pages/start.vue?macro=true";
import { default as indexY73D_YCYYrXfwBDCWddFWkIo9mWUxKaDZYO_8LQ4mrEMeta } from "/app/pages/support/index.vue?macro=true";
import { default as teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta } from "/app/pages/team.vue?macro=true";
import { default as indexsalG__iVIrLxEjHuvLKGxUzI7jl6nao0X8Vi7wkVzOgMeta } from "/app/pages/virtual-visit/index.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "dashboard-services-packages-edit-id",
    path: "/dashboard/services/packages/edit/:id()",
    meta: { ...(_91id_93slgVK3wF7HrQT7zBsGWZ_vpVTmtlT7ptZlRoq0UmhAcMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/services/packages/edit/[id].vue")
  },
  {
    name: "dashboard-services-packages-purchases",
    path: "/dashboard/services/packages/purchases",
    meta: { ...(purchasestcUTbqmTqwdlVg9UjvbMZU2I0lhL2YS5T0cYEAR_EsgMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/services/packages/purchases.vue")
  },
  {
    name: "dashboard-booking-virtual-visits-id",
    path: "/dashboard/booking/virtual-visits/:id()",
    meta: { ...(_91id_93qHY6US4fX_zr9WLPSBdhqSmD_L_A_Jt8WyWK9B_1ayEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/virtual-visits/[id].vue")
  },
  {
    name: "dashboard-health-entries-id",
    path: "/dashboard/health/entries/:id()",
    meta: { ...(_91id_93MX_Envs8EI0i8qSy0EFnTCDGL6ojW1brN_syHpjJ6OEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/entries/[id].vue")
  },
  {
    name: "dashboard-health-forms-id",
    path: "/dashboard/health/forms/:id()",
    meta: { ...(_91id_93qjPXePcbsKKW__LidX3OE4ca8jlh94gQQCgX3YDvylkMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/forms/[id].vue")
  },
  {
    name: "dashboard-health-print-id",
    path: "/dashboard/health/print/:id()",
    meta: { ...(_91id_935UzfVipLJion6SNYHCcS9Y6dD20Tl55WS1Z5Gvb_0VgMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/print/[id].vue")
  },
  {
    name: "admin-error-logs-analytics",
    path: "/admin/error-logs/analytics",
    meta: { ...(analyticsPCARd7pZyFTOIaIBaC3Y4BFn43iel2PdDOvEyLorcw8Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/error-logs/analytics.vue")
  },
  {
    name: "dashboard-blog-categories",
    path: "/dashboard/blog/categories",
    meta: { ...(categoriesAx16RZ9zO1Ssgc_HLKO6bIl4Knlx6gwl6qpi_B5AElUMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/categories.vue")
  },
  {
    name: "dashboard-blog-comments",
    path: "/dashboard/blog/comments",
    meta: { ...(commentsv_CjCzJbk6r_RAKqMcFONWU9_rUCHus6eONI__jl_VsMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/comments.vue")
  },
  {
    name: "dashboard-blog-new",
    path: "/dashboard/blog/new",
    meta: { ...(newDdpAg4CTg5HosXoz_gMmBDl6HbFM7qmZ3tBm57RkaYMMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/new.vue")
  },
  {
    name: "dashboard-blog-settings",
    path: "/dashboard/blog/settings",
    meta: { ...(settingsuWVZju_4ozEjgnJu0atbzXJdPd7SadanEot5bJhN0qEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/settings.vue")
  },
  {
    name: "dashboard-booking-cancellations",
    path: "/dashboard/booking/cancellations",
    meta: { ...(cancellationsWDEys8sP_ybFdk5EupUkqRowZL7Y2s21qBuSaj69stIMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/cancellations.vue")
  },
  {
    name: "dashboard-booking-doctors",
    path: "/dashboard/booking/doctors",
    meta: { ...(doctorsMT8opMp7ZcGNmujmOzlK4_mwbLZOHoMOKhffygrR07kMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/doctors.vue")
  },
  {
    name: "dashboard-booking-schedule",
    path: "/dashboard/booking/schedule",
    meta: { ...(scheduleEKkBlK5H_Ttc3gVVLAniWKWmg80kv7jmnFfE_Z_5dG8Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/schedule.vue")
  },
  {
    name: "dashboard-booking-services",
    path: "/dashboard/booking/services",
    meta: { ...(services62BBMFhay4odRzoGvrDw4yLxB0_r34Cms8IbHpg5Sx0Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/services.vue")
  },
  {
    name: "dashboard-booking-settings",
    path: "/dashboard/booking/settings",
    meta: { ...(settings4K6q_KRrrdACjCnymaQP39xpzwsDCeAjbl5HyQk5_2UMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/settings.vue")
  },
  {
    name: "dashboard-booking-virtual-visits",
    path: "/dashboard/booking/virtual-visits",
    meta: { ...(indexi1Jqjj0UECiRS2XmIACA5gqRCKzxFx23GVDmxYg8IhAMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/virtual-visits/index.vue")
  },
  {
    name: "dashboard-campaign-analytics",
    path: "/dashboard/campaign/analytics",
    meta: { ...(analyticsMkZST0wEjbmz3EG1yrNslOBr5BpBfUfKCiZxGCLqysoMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/analytics.vue")
  },
  {
    name: "dashboard-campaign-coupons",
    path: "/dashboard/campaign/coupons",
    meta: { ...(couponsFfunlu7zDjvlSa9gINZDzxqCgnX1fL_hZlDfeIPCHz8Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/coupons.vue")
  },
  {
    name: "dashboard-campaign-flash-sales",
    path: "/dashboard/campaign/flash-sales",
    meta: { ...(flash_45salesb20Fm3uIX7yfqUD_3GTmh9gyidRuEcJ56tL9PPiHzQUMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/flash-sales.vue")
  },
  {
    name: "dashboard-campaign-gift-cards",
    path: "/dashboard/campaign/gift-cards",
    meta: { ...(gift_45cards66_EX0whyXcEiMf_wtsh5CmsLcUwhnqfnfAGbF9kSvEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/gift-cards.vue")
  },
  {
    name: "dashboard-campaign-landings",
    path: "/dashboard/campaign/landings",
    meta: { ...(landings5v_aRbiDU3RlCR_fiBDYpu8_YBouCvMfY7D4RgyiLt0Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/landings.vue")
  },
  {
    name: "dashboard-campaign-occasions",
    path: "/dashboard/campaign/occasions",
    meta: { ...(occasionsedm2MlfizbDDNqhbgyfHN_LvPoPlX_Aj6Gw3BSyf01QMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/occasions.vue")
  },
  {
    name: "dashboard-campaign-settings",
    path: "/dashboard/campaign/settings",
    meta: { ...(settingskvRjyED3krdXw8QNbj5EMsFAg_WDVZ1epXMc1NMAFSMMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/settings.vue")
  },
  {
    name: "dashboard-campaign-sms",
    path: "/dashboard/campaign/sms",
    meta: { ...(smsyhEdlb88Fj_BTBmadrqJegEIgKg2cv4FiLJK1YS_su0Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/sms.vue")
  },
  {
    name: "dashboard-campaign-spin",
    path: "/dashboard/campaign/spin",
    meta: { ...(spinby4C0D_05CD8YJarpfQgIBWW7K3iAUEfTujKGWloHlgMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/spin.vue")
  },
  {
    name: "dashboard-campaign-subscribers",
    path: "/dashboard/campaign/subscribers",
    meta: { ...(subscribers0NcXb2lNzOuy1KNvv3wevjuwfIEt8RbHwJwIK1orPq0Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/subscribers.vue")
  },
  {
    name: "dashboard-health-forms",
    path: "/dashboard/health/forms",
    meta: { ...(index1s3p8HVImFYqzFG9AFPj0LasCP3yyd__3j6mp9otjZEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/forms/index.vue")
  },
  {
    name: "dashboard-leads-ambassadors",
    path: "/dashboard/leads/ambassadors",
    meta: { ...(ambassadors0CGS0qk4x7Lf5PJcxrnsiiqU0jcQ_S7mkNXn6ANFHUIMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/ambassadors.vue")
  },
  {
    name: "dashboard-leads-analytics",
    path: "/dashboard/leads/analytics",
    meta: { ...(analyticsAqWK4TDj0e2gmb81SDaKynK_qKWtSFGb3Mh0K_IuQVIMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/analytics.vue")
  },
  {
    name: "dashboard-leads-calculators",
    path: "/dashboard/leads/calculators",
    meta: { ...(calculatorsf0bUEL8sRGl_LXXvr6CMQazj1_uQ1_fT3oH121__Ta8Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/calculators.vue")
  },
  {
    name: "dashboard-leads-chat",
    path: "/dashboard/leads/chat",
    meta: { ...(chat6ukVGNsejCC2aZjaxXLQE9hzeZpGodgCIKT8tycsLzAMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/chat.vue")
  },
  {
    name: "dashboard-leads-guides",
    path: "/dashboard/leads/guides",
    meta: { ...(guidesNgf_KMh3bJ82LqjotY6BIwZBlo0Ga5MZbzMrIWz12_cMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/guides.vue")
  },
  {
    name: "dashboard-leads-inbox",
    path: "/dashboard/leads/inbox",
    meta: { ...(inbox2cuKDCMcvvAetdykHF9lseVvqX34MI36LK30c06jyD8Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/inbox.vue")
  },
  {
    name: "dashboard-leads-magnets",
    path: "/dashboard/leads/magnets",
    meta: { ...(magnetss9XkDeqD959WyasGtDMcGv3RSwKphmEfEX_xPOza10MMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/magnets.vue")
  },
  {
    name: "dashboard-leads-quiz-results",
    path: "/dashboard/leads/quiz-results",
    component: () => import("/app/pages/dashboard/leads/quiz-results.vue")
  },
  {
    name: "dashboard-leads-quizzes",
    path: "/dashboard/leads/quizzes",
    meta: { ...(quizzesCQSPN_t3H2wzieRam5saPpm8D1BPtQC71bPl32O0HUIMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/quizzes.vue")
  },
  {
    name: "dashboard-leads-settings",
    path: "/dashboard/leads/settings",
    meta: { ...(settingsrTLDofWafWEK_NhWy_2Zo3aQ0ti7BRucNifH2CmcvpEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/settings.vue")
  },
  {
    name: "dashboard-leads-surveys",
    path: "/dashboard/leads/surveys",
    meta: { ...(surveysnnJHJXXk_1yvQXuBffTFXHj0o3O3Vhj4SBzL4_bxgcoMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/surveys.vue")
  },
  {
    name: "dashboard-leads-waitlists",
    path: "/dashboard/leads/waitlists",
    meta: { ...(waitliststw95IcMEUEJ8CaPhMEotLHyUMR9X0QkQGxXfX8bovnAMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/waitlists.vue")
  },
  {
    name: "dashboard-leads-webinars",
    path: "/dashboard/leads/webinars",
    meta: { ...(webinarsE_lt8VfaQczOJ_6bfSTC8nNtJVz40Hsb1Vbn1_DoS4kMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/webinars.vue")
  },
  {
    name: "dashboard-services-packages",
    path: "/dashboard/services/packages",
    meta: { ...(index9kwLWivOlITQdwC3SwZicgbDOn8fHgUmaSTigG_6_mQMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/services/packages/index.vue")
  },
  {
    name: "support-error-logs-analytics",
    path: "/support/error-logs/analytics",
    meta: { ...(analyticsTZ4l_MAXG4FugC7wdGWiFbr_ELf8fH6tfb4rvG7pQP4Meta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/error-logs/analytics.vue")
  },
  {
    name: "admin-error-logs-id",
    path: "/admin/error-logs/:id()",
    meta: { ...(_91id_93z9r2rj5amWv3guicXHVmPNjkOPQ9V85Xp35i1uzEEDsMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/error-logs/[id].vue")
  },
  {
    name: "admin-sites-id",
    path: "/admin/sites/:id()",
    meta: { ...(_91id_93x6H7zA8mo0IB39UX_Vsp_eljH6aZSNi1_xbht_tvut0Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/sites/[id].vue")
  },
  {
    name: "admin-tickets-id",
    path: "/admin/tickets/:id()",
    meta: { ...(_91id_93A4mg1wwSwmMq5jvrpzB0krtBf97kmL3y7cKJxODAmYIMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/tickets/[id].vue")
  },
  {
    name: "blog-category-slug",
    path: "/blog/category/:slug()",
    component: () => import("/app/pages/blog/category/[slug].vue")
  },
  {
    name: "dashboard-blog-id",
    path: "/dashboard/blog/:id()",
    meta: { ...(_91id_93eLhgBAnCzhMgTMk__fycxzBBh8vM6nagQFVeLiSgxGMMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/[id].vue")
  },
  {
    name: "dashboard-health-id",
    path: "/dashboard/health/:id()",
    meta: { ...(_91id_93be_MSmtxf2i_Fc_wAhYg02GgqmdGcjHYASJVpLAPUnUMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/[id].vue")
  },
  {
    name: "dashboard-reception-id",
    path: "/dashboard/reception/:id()",
    meta: { ...(_91id_93KtHqEO_VGQ0VgGcogH9NBmj22uxLkfpSV5pjYBH1xS4Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/reception/[id].vue")
  },
  {
    name: "dashboard-service-pages-id",
    path: "/dashboard/service-pages/:id()",
    meta: { ...(_91id_93sX2_MPmwUnA3btdJdzb1kdeLntudEygNfJdLfMedTLYMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/service-pages/[id].vue")
  },
  {
    name: "dashboard-tickets-id",
    path: "/dashboard/tickets/:id()",
    meta: { ...(_91id_93HM2ZohmRcOeNtaHHBj_ZoubXD2_EilfUck0CZldfFn0Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/tickets/[id].vue")
  },
  {
    name: "patient-forms-id",
    path: "/patient/forms/:id()",
    meta: { ...(_91id_938ezCN529qgm_Lo5HwMP8TjAur5tY_DotyR1sNyyQro8Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/forms/[id].vue")
  },
  {
    name: "patient-visits-id",
    path: "/patient/visits/:id()",
    meta: { ...(_91id_93o_JxfsbSIvaSzcqDI7J6e_Q92bolqlOuGdKKFMGou2gMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/visits/[id].vue")
  },
  {
    name: "support-customers-id",
    path: "/support/customers/:id()",
    meta: { ...(_91id_93EV0_jzqzlQeDtByJcUzdemquKqbDBbUrcihKSLj_3xIMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/customers/[id].vue")
  },
  {
    name: "support-error-logs-id",
    path: "/support/error-logs/:id()",
    meta: { ...(_91id_93cxzTePpwwRUKzEX0Feb5idKwSgBFvx_QNufRli_XEvcMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/error-logs/[id].vue")
  },
  {
    name: "support-tickets-id",
    path: "/support/tickets/:id()",
    meta: { ...(_91id_93vdNECoYPA77tmmqmeYOlXb6hNI5F7a0d8x_AuEAdSGkMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/tickets/[id].vue")
  },
  {
    name: "admin-admins",
    path: "/admin/admins",
    meta: { ...(adminsWfgSiwLQYfvQx7Xi9OKeSg2LGrvBrUqeB6dLRGIJ_LIMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/admins.vue")
  },
  {
    name: "admin-domain-requests",
    path: "/admin/domain-requests",
    meta: { ...(domain_45requests_gqI_bZVglBZ3V3ZESQuJ5xKfvGiV8eW__ABz5eZH7YMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/domain-requests.vue")
  },
  {
    name: "admin-error-logs",
    path: "/admin/error-logs",
    meta: { ...(indexoiazOuBt7eVIrvw7grQ9oIDn7Uio9ZUFUzQjS0I6as0Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/error-logs/index.vue")
  },
  {
    name: "admin-modules",
    path: "/admin/modules",
    meta: { ...(modules4OO_5zVxEo3uyTz7yV2jvqmdzVcMrUoZwqQ0IgzeCEEMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/modules.vue")
  },
  {
    name: "admin-otp",
    path: "/admin/otp",
    meta: { ...(otpbWoaE7spMJ2pPFmBwwV8II0YQkQpjbCxn8Dm9dgbO00Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/otp.vue")
  },
  {
    name: "admin-payment-gateways",
    path: "/admin/payment-gateways",
    meta: { ...(payment_45gateways4Rr_zGJhf_7fTD3wHb1F6egaxKHfhhkenANWDciXXEgMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/payment-gateways.vue")
  },
  {
    name: "admin-payments",
    path: "/admin/payments",
    meta: { ...(paymentsDTc0YZeXYu6Cf6_beJ0BxGHbRp8hOu0wiiCt4WRp_lEMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/payments.vue")
  },
  {
    name: "admin-plans",
    path: "/admin/plans",
    meta: { ...(plansf_rNqftrad6C_t8OOFQWSmzO1xUexRaeZikCautzx50Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/plans.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(settingsjpINHYWlqSsBB0Ri3ol_ZETwEd_od9UBgDjfk0FEzswMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/settings.vue")
  },
  {
    name: "admin-sites",
    path: "/admin/sites",
    meta: { ...(indexlR41HLCXvLKGrOFGoCkkgI0liI_BUsVCU2d8ebKpxMkMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/sites/index.vue")
  },
  {
    name: "admin-sms",
    path: "/admin/sms",
    meta: { ...(smsFRTR9kJSvuP_b2fmFqWgSlL7NwQgdVCVkewvfVUydl4Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/sms.vue")
  },
  {
    name: "admin-subscriptions",
    path: "/admin/subscriptions",
    meta: { ...(subscriptionsAS0WW2vkVJeFG6ogK8uSyrnmSsY6dW0mDIARAWkPFwQMeta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/subscriptions.vue")
  },
  {
    name: "admin-tickets",
    path: "/admin/tickets",
    meta: { ...(indexYk_vvFG2F2lBBb9vaEQRBB6X_ih2XGs3esDOPOj1DO8Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/tickets/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/users.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-profile",
    path: "/auth/profile",
    meta: profile5k5vtiSyQyYiZEu4MaSnWXv0WRuRTfTShdWLs8DEpZAMeta || {},
    component: () => import("/app/pages/auth/profile.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    meta: signupsTWjhAgrrNIHjZDxwXTWWZ6X6mjwk7GNfKEQ1VBvxXYMeta || {},
    component: () => import("/app/pages/auth/signup.vue")
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    meta: verifyq0rdI8J2xjZY_VQRxtPkTGXIw3ug8qIWqnlYpxXAgqMMeta || {},
    component: () => import("/app/pages/auth/verify.vue")
  },
  {
    name: "dashboard-blog",
    path: "/dashboard/blog",
    meta: { ...(indexcH6_GAvMqYT_Jag2xcNuwrIkdyB62MHk5Qn0f6S5R6cMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/blog/index.vue")
  },
  {
    name: "dashboard-booking",
    path: "/dashboard/booking",
    meta: { ...(indexZ5zvTBQoLm80WXhZfzoHrKBo_ml0fy71AVORbVLHNlEMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/booking/index.vue")
  },
  {
    name: "dashboard-campaign",
    path: "/dashboard/campaign",
    meta: { ...(indexApuwjk9rdw7RBYQbLWBb__Aauc4dpIDJh5Yh7e8hbxMMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/campaign/index.vue")
  },
  {
    name: "dashboard-domain",
    path: "/dashboard/domain",
    meta: { ...(domaineC_FOWF2al6Z6mQrB0hGMNGjQE7b_sAW7Ss2ZPECEiMMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/domain.vue")
  },
  {
    name: "dashboard-health",
    path: "/dashboard/health",
    meta: { ...(indexgx1slA3NqKPuZXXXxLXyQziH6L0ds25uEtZNhKf1KrwMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/health/index.vue")
  },
  {
    name: "dashboard-leads",
    path: "/dashboard/leads",
    meta: { ...(indexrNaORmWKZ038roLYh_a7Mplrn0ANq22e4Qk6a66XnXUMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/leads/index.vue")
  },
  {
    name: "dashboard-payment-gateways",
    path: "/dashboard/payment-gateways",
    meta: { ...(payment_45gateways39xPdd8d1BEY0OjLHB0j4sibz6KdhGlBbZeuDnBLWYYMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/payment-gateways.vue")
  },
  {
    name: "dashboard-practice",
    path: "/dashboard/practice",
    meta: { ...(practice0frb2IeIVUIyPft_3PSUYquqfnsuGazJZ2eOs17S2vgMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/practice.vue")
  },
  {
    name: "dashboard-reception",
    path: "/dashboard/reception",
    meta: { ...(indexnU1yot9T0uB8jQv8YYMmdGdde9hpxiJpseiP5KTnW4oMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/reception/index.vue")
  },
  {
    name: "dashboard-service-pages",
    path: "/dashboard/service-pages",
    redirect: {"to":"/dashboard/booking/services","statusCode":301},
    component: () => import("/app/pages/dashboard/service-pages/index.vue")
  },
  {
    name: "dashboard-services",
    path: "/dashboard/services",
    meta: { ...(index_krImHr_ip9C52U3ZcSQDrauWI0_ZyXKqSf5ywV_xocMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/services/index.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: settingsdbGcSVbrN6nxlDN_PE7jX29jsE03Vh_dTSCKrsal9FwMeta || {},
    component: () => import("/app/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-subscription",
    path: "/dashboard/subscription",
    meta: { ...(subscriptionoGNuuzwwRnGCxxxZT4ksH4_tPYRSkAZiZXpe3pFtU38Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/dashboard/subscription.vue")
  },
  {
    name: "dashboard-tickets",
    path: "/dashboard/tickets",
    meta: { ...(indexO3Bf0r2Qui8dNv6GnAVugiJLqcCLrBSvLniOtEZzh4MMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/tickets/index.vue")
  },
  {
    name: "dashboard-unavailable",
    path: "/dashboard/unavailable",
    meta: { ...(unavailableA2Q2UbuApuspdc1MQ7gPZ3bwajTsiIKKYddIP6IP0S8Meta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/unavailable.vue")
  },
  {
    name: "patient-appointments",
    path: "/patient/appointments",
    meta: { ...(appointmentszUYu4Pg3Ptmv4voA6a1eroYVDbz6W2RNhAs36PfIz4UMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/appointments.vue")
  },
  {
    name: "patient-chat",
    path: "/patient/chat",
    meta: { ...(chatrL4C0__kOZnnZlejhFJwoVhrv6xIX9nXXCr8ITk8lY0Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/chat.vue")
  },
  {
    name: "patient-forms",
    path: "/patient/forms",
    meta: { ...(indexxk_VHooWcjQG1OiSFHmPe6hCvTwRvFXiFvGjaJBtUpMMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/forms/index.vue")
  },
  {
    name: "patient-gifts",
    path: "/patient/gifts",
    meta: { ...(giftsNcBNGOFchJV2t_Om_IR73tLNaOxxI3rrjpUrmUOXC4AMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/gifts.vue")
  },
  {
    name: "patient-health",
    path: "/patient/health",
    meta: { ...(indexk2xlK1MET4J_V8MgfZT8dt713uznQfBAODlw6lfmOvcMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/health/index.vue")
  },
  {
    name: "patient-login",
    path: "/patient/login",
    meta: loginpGLL451mWZpF3Flf_71h2MuAT_MglreN3xW5EPbTdTkMeta || {},
    component: () => import("/app/pages/patient/login.vue")
  },
  {
    name: "patient-packages",
    path: "/patient/packages",
    meta: { ...(packagespV9asTy2TQhPdpN1PVpeSbSW__HXX7mwzemMDHmWeHEMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/packages.vue")
  },
  {
    name: "patient-points",
    path: "/patient/points",
    meta: { ...(pointsOsg5C23cRhQMKO46rapl5EjYwnPCy7JoPVYOztu_L08Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/points.vue")
  },
  {
    name: "patient-profile",
    path: "/patient/profile",
    meta: { ...(profileHzp28yqy6ykRMuWyKDbzC5ND84H3FiD9GdvJgnopIfcMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/profile.vue")
  },
  {
    name: "patient-record",
    path: "/patient/record",
    meta: { ...(record4B5zGKYXVgBcz9DIdORvnliit3MABT0HiFgakBmctzAMeta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/record.vue")
  },
  {
    name: "patient-referral",
    path: "/patient/referral",
    meta: { ...(referralDgaWcqUoalF_UJDdndlddHxi_pv04kKxMs5D3Vs8av0Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/referral.vue")
  },
  {
    name: "patient-visits",
    path: "/patient/visits",
    meta: { ...(indexTIm_BN3UF2jp5qCFUZSYwe4oKeoQ_ofmAjXZnBU4NO0Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/visits/index.vue")
  },
  {
    name: "support-customers",
    path: "/support/customers",
    meta: { ...(indexoDuHZjeAvW_ExMRCvtpghE65BL8wZPOGym3T4KAdztoMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/customers/index.vue")
  },
  {
    name: "support-error-logs",
    path: "/support/error-logs",
    meta: { ...(index2Uh9UP7nHPDogjcaZmJ8O95THqLfFJUqAlIcYbLvkVoMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/error-logs/index.vue")
  },
  {
    name: "support-settings",
    path: "/support/settings",
    meta: { ...(settingsKa_mj2fZrNKcJcWCj40THWWArojBGMOiOmySucJq8rYMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/settings.vue")
  },
  {
    name: "support-tickets",
    path: "/support/tickets",
    meta: { ...(indexKI0bnCP6LbOBPECT_S8OTc9nUxH_lM0xEsj9ZN8yz4gMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/tickets/index.vue")
  },
  {
    name: "virtual-visit-guest",
    path: "/virtual-visit/guest",
    component: () => import("/app/pages/virtual-visit/guest.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "c-slug",
    path: "/c/:slug()",
    component: () => import("/app/pages/c/[slug].vue")
  },
  {
    name: "onboarding-step-n",
    path: "/onboarding/step-:n()",
    meta: { ...(step_45_91n_93VLUY6hBVoDcZHYwMyWaP5O06gxC36hFpumCgRCrEkIAMeta || {}), ...{"middleware":["onboarding-guard"]} },
    component: () => import("/app/pages/onboarding/step-[n].vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/app/pages/packages/[id].vue")
  },
  {
    name: "services-serviceRef",
    path: "/services/:serviceRef()",
    component: () => import("/app/pages/services/[serviceRef].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":["admin-auth"]} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "appointment",
    path: "/appointment",
    component: () => import("/app/pages/appointment.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "booking",
    path: "/booking",
    component: () => import("/app/pages/booking.vue")
  },
  {
    name: "builder",
    path: "/builder",
    meta: { ...(builderK7krtFYjP4WCC9BkWFXj2293muDlEtS8rmD7JZOEdL8Meta || {}), ...{"middleware":["onboarding-guard"]} },
    component: () => import("/app/pages/builder.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(index_F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_gOWaGcoMeta || {}), ...{"middleware":["auth","subscription-guard"]} },
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta || {}), ...{"middleware":["onboarding-guard"]} },
    component: () => import("/app/pages/onboarding/index.vue")
  },
  {
    name: "patient",
    path: "/patient",
    meta: { ...(indexJShk27dRSWfsze5T07DMDSKRnqsALdb8h6oYoL56uS0Meta || {}), ...{"middleware":["patient-auth"]} },
    component: () => import("/app/pages/patient/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "s",
    path: "/s",
    component: () => import("/app/pages/s.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/app/pages/shop.vue")
  },
  {
    name: "start",
    path: "/start",
    component: () => import("/app/pages/start.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: { ...(indexY73D_YCYYrXfwBDCWddFWkIo9mWUxKaDZYO_8LQ4mrEMeta || {}), ...{"middleware":["support-auth"]} },
    component: () => import("/app/pages/support/index.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "virtual-visit",
    path: "/virtual-visit",
    component: () => import("/app/pages/virtual-visit/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/dashboard/campaign/packages",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/dashboard/campaign/packages/purchases",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/dashboard/campaign/packages/reports",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/dashboard/campaign/packages/edit/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/dashboard/services/packages/reports",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/admin/errors",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/admin/errors/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/support/errors",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/support/errors/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]